module.exports = __webpack_public_path__ + "img/52.7301e1df.jpg";